<!--设备管理-->
<template>
  <div class="khgl_page_box common_page_box">
    <page_layout_slot_two
      :show_pull_down="is_pull_up"
      @pull_down="is_pull_up = false"
    >
      <div slot="content_up">
        <!--占位-->
        <div v-show="is_pull_up" style="width: 100%;height: 10px;"></div>

        <!--表单-->
        <el-form
          :model="queryParams"
          ref="queryForm"
          :inline="true"
          class="filterBox"
          v-show="!is_pull_up"
          label-width="100px"
        >
          <el-form-item label="设备名称">
            <el-input
              v-model="queryParams.deviceName"
              placeholder="请输入"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="所属组织">
            <el-input
              v-model="queryParams.organization"
              placeholder="请输入"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="设备状态">
            <el-select
              v-model="queryParams.status"
              popper-class="product_select_customize"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in statusOption"
                :key="item.number"
                :label="item.name"
                :value="item.number"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <!--按钮-->
        <div
          style="width:180px;margin:10px 30%;display:flex;align-items:center;"
          v-show="!is_pull_up"
        >
          <el-button size="small" type="primary" @click="handleQuery"
            >查询</el-button
          >
          <el-button size="small" type="primary" @click="resetQuery"
            >重置</el-button
          >
          <span @click="is_pull_up = true" class="pull_up_box"
            >收起<i class="el-icon-arrow-up"></i
          ></span>
        </div>
      </div>

      <div slot="content_down" class="content_down_s" style="height: 100%;">
        <!--查询结果显示条-->
        <div class="query_res_info">
          <div>
            <i class="el-icon-success icon"></i>
            <span class="text"
              >共查询到<span class="total_num">{{ total || 0 }}</span
              >条数据</span
            >
          </div>
          <div>
            <el-button
              @click="handleSync"
              v-loading="syncLoading"
              size="small"
              style="margin-left: 20px;"
              type="primary"
              >同步</el-button
            >
          </div>
        </div>

        <div
          class="query_res_table"
          style="height: calc(100% - 100px);position: relative"
        >
          <div
            style="width: 100%;height: 100%;position: absolute;left: 0;top: 0"
          >
            <el-table height="100%" v-loading="loading" :data="tableList">
              <el-table-column
                type="index"
                width="55"
                label="序号"
                align="center"
              />

              <el-table-column label="设备名称" align="center" prop="name" />
              <el-table-column label="设备类型" align="center" prop="type">
                <template slot-scope="scope">
                  {{ scope.row.type == "1" ? "DVR" : "IPC" }}
                </template>
              </el-table-column>
              <el-table-column
                label="设备序列号"
                align="center"
                prop="snNumber"
              />
              <el-table-column label="所属组织" align="center">
                <template slot-scope="scope">
                  {{ scope.row.ckmc ? scope.row.ckmc : scope.row.mdmc }}
                </template>
              </el-table-column>
              <el-table-column
                label="设备安装位置"
                align="center"
                prop="qhmc"
              />
              <el-table-column
                label="设备厂商"
                align="center"
                prop="manufacturer"
              />
              <el-table-column label="设备状态" align="center" prop="sbazwz">
                <template slot-scope="scope">
                  {{ scope.row.status == 0 ? "离线" : "在线" }}
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    @click="handleDetail(scope.row)"
                    >详情</el-button
                  >
                  <el-button
                    size="mini"
                    type="text"
                    @click="handleEdit(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="page_info">
          <el-pagination
            @current-change="getList"
            :current-page.sync="queryParams.pageNumber"
            :page-size="queryParams.pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </page_layout_slot_two>
    <detail-dialog ref="detail_dialog" @onClose="resetQuery"></detail-dialog>
  </div>
</template>

<script>
import Page_layout_slot_two from "@/components/yxgl_system/page_layout_slot_two";
import DetailDialog from "./detailDialog.vue";
import API from "../../../../../api/api_asset/api_asset";
export default {
  name: "index",
  components: {
    Page_layout_slot_two,
    DetailDialog
  },
  data() {
    return {
      is_pull_up: false,
      loading: false,
      total: 0,
      tableList: [],

      /*信息类型*/
      statusOption: [
        { number: 0, name: "离线" },
        { number: 1, name: "在线" },
        { number: -1, name: "全部" }
      ],

      queryParams: {
        pageNumber: 1,
        pageSize: 10,
        deviceName: "",
        organization: "",
        status: -1
      },
      syncLoading: false
    };
  },
  created() {
    this.getList();
  },

  methods: {
    /*列表查询*/
    async getList() {
      let that = this;
      this.loading = true;
      try {
        let res = await API.getListDevice({
          deviceName: this.queryParams.deviceName,
          organization: this.queryParams.organization,
          page: this.queryParams.pageNumber,
          pageSize: this.queryParams.pageSize,
          status: this.queryParams.status
        });

        if (res.code == 200) {
          let tableList = res.data.records || [];
          this.tableList = tableList;
          this.total = res.data.total || 0;
          this.loading = false;
        } else {
          this.loading = false;
          this.GLOBAL.common_tool.warning(res.msg || "查询设备列表数据错误");
          this.GLOBAL.common_tool.sys_reason_log(
            res.msg + "_" + "查询设备列表数据错误"
          );
        }
      } catch (err) {
        that.loading = false;
        that.GLOBAL.common_tool.warning("查询专家管理列表数据异常");
        that.GLOBAL.common_tool.sys_reason_log(
          err + "_" + "查询专家管理列表数据异常"
        );
      }
    },

    /*重置分页*/
    resetpage() {
      this.queryParams.pageNumber = 1;
    },

    // 表单重置
    resetFilter() {
      this.queryParams.pageNumber = 1;
      this.queryParams.pageSize = 10;
      this.queryParams.deviceName = "";
      this.queryParams.organization = "";
      this.queryParams.status = -1;
    },

    /*搜索按钮操作*/
    handleQuery() {
      this.resetpage();
      this.getList();
    },

    /*重置按钮操作*/
    resetQuery() {
      this.resetFilter();
      this.handleQuery();
    },
    /*编辑*/
    handleEdit(row) {
      this.$refs.detail_dialog.init(row, true);
    },
    /** 详情按钮操作 */
    handleDetail(row) {
      this.$refs.detail_dialog.init(row, false);
    },

    /** 同步按钮操作 */
    async handleSync() {
      this.syncLoading = true;
      let res = await API.flushDevice();
      console.log(`res :`,res)
      if (res.code == 200) {
        this.GLOBAL.common_tool.success("同步成功");
        this.resetQuery();
      } else {
        this.GLOBAL.common_tool.warning(res.msg || "同步失败");
        this.GLOBAL.common_tool.sys_reason_log(res.msg + "_" + "同步失败");
      }
       this.syncLoading = false;
    }
  }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/wlwyzt_asset.vue